/* ---------------------------------------------------------------------------
   TRAWOC — copy a discount code to the clipboard.
   Progressive enhancement: the code is readable and selectable without this.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  function flash(button, label) {
    var original = button.dataset.twLabel || button.querySelector('[data-tw-code-text]').textContent;
    button.dataset.twLabel = original;
    button.querySelector('[data-tw-code-text]').textContent = label;
    button.classList.add('is-copied');
    clearTimeout(button._twTimer);
    button._twTimer = setTimeout(function () {
      button.querySelector('[data-tw-code-text]').textContent = button.dataset.twLabel;
      button.classList.remove('is-copied');
    }, 1600);
  }

  function legacyCopy(text) {
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '0';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (e) {
        ok = false;
      }
      document.body.removeChild(ta);
      ok ? resolve() : reject(new Error('copy unavailable'));
    });
  }

  /* The async clipboard API rejects without transient user activation, and is
     absent over plain http. Fall through to the legacy path either way. */
  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function () {
        return legacyCopy(text);
      });
    }
    return legacyCopy(text);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-tw-copy]');
    if (!button) return;
    event.preventDefault();

    var code = button.getAttribute('data-tw-copy');
    var done = button.getAttribute('data-tw-copied-label') || 'Copied';

    copy(code).then(
      function () { flash(button, done); },
      function () {
        /* Nothing worked — select the code so it can be copied by hand. */
        var span = button.querySelector('[data-tw-code-text]');
        var range = document.createRange();
        range.selectNodeContents(span);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      }
    );
  });
})();
